"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProfilingSupported = isProfilingSupported;
const browser_core_1 = require("@datadog/browser-core");
function isProfilingSupported() {
    const globalThis = (0, browser_core_1.getGlobalObject)();
    // This API might be unavailable in some browsers
    const globalThisProfiler = globalThis.Profiler;
    return globalThisProfiler !== undefined;
}
//# sourceMappingURL=profilingSupported.js.map